import React, { useEffect } from 'react';

import { getBrowserLanguageCode } from 'helpers/language.helper';

import './NoAccess.scss';

const NO_ACCESS_COPY = {
  en: {
    title: 'Access Denied | Experience Studio @ Flybits',
    header: 'Access Denied',
    descriptionPrefix: 'You do not have enough permissions to access Experience Studio. Please ',
    descriptionBold: ' contact an administrator. ',
  },
  fr: {
    title: 'Accès refusé | Experience Studio @ Flybits',
    header: 'Accès refusé',
    descriptionPrefix: 'Vous ne disposez pas des autorisations suffisantes pour accéder à Experience Studio. Veuillez ',
    descriptionBold: ' contacter un administrateur. ',
  },
} as const;

const language = getBrowserLanguageCode(Object.keys(NO_ACCESS_COPY) as (keyof typeof NO_ACCESS_COPY)[]);
const copy = NO_ACCESS_COPY[language];

export default function NoAccess() {
  useEffect(() => {
    document.title = copy.title;
  }, []);

  return (
    <div className="no-access">
      <div className="header">{copy.header}</div>
      <div className="description">
        <p>
          {copy.descriptionPrefix}
          <b>{copy.descriptionBold}</b>
        </p>
      </div>
    </div>
  );
}
